module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/banner/en-a80ad5c9158fccb8310b46dce86b9448.jpg";